module.exports = __webpack_public_path__ + "img/ring_y_l_1_0.5252bd3c.png";